import type { FlowEditorSDK } from '@wix/yoshi-flow-editor';

export const openDashboard = (
  editorSDK: FlowEditorSDK,
  isAddQuestion?: boolean,
  isAddCategory?: boolean,
) => {
  let url = 'app/14c92d28-031e-7910-c9a8-a670011e062d';
  if (isAddQuestion) {
    url = 'app/14c92d28-031e-7910-c9a8-a670011e062d?isAddQuestion=true';
  } else if (isAddCategory) {
    url = 'app/14c92d28-031e-7910-c9a8-a670011e062d?isAddCategory=true';
  }

  editorSDK.editor.openDashboardPanel('', {
    url,
    closeOtherPanels: false,
  });
};
